// ChatInput.js - Optimized input component
import React, { memo } from 'react';
import { Send, Settings, Users } from 'lucide-react';
import EmojiPicker from './EmojiPicker';

const ChatInput = memo(({ 
  message, 
  onMessageChange, 
  onSubmit, 
  isConnected, 
  artistName, 
  onSettingsClick, 
  onModerateClick 
}) => {
  // Check if user can moderate
  const canModerate = () => {
    const memberDataString = localStorage.getItem('_ms-mem');
    const memberData = memberDataString ? JSON.parse(memberDataString) : null;
    const currentUserName = (memberData?.customFields?.name || '').toLowerCase().trim();
    const cleanArtistName = artistName.replace('/s/', '').replace('s/', '').toLowerCase().trim();
    const isAlphaArtist = memberData?.planConnections?.some(
      plan => plan.planId === 'pln_alphaartist-9s5e06q6' && plan.status === 'ACTIVE'
    );
    const isOwnPage = currentUserName === cleanArtistName;
    
    return isAlphaArtist && isOwnPage;
  };

  const handleEmojiSelect = (emoji) => {
    onMessageChange(message + emoji);
  };

  return (
    <form onSubmit={onSubmit} style={{
      padding: '1rem',
      borderTop: '1px solid rgba(55, 65, 81, 0.2)',
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem'
    }}>
      <div style={{ 
        display: 'flex',
        position: 'relative',
        width: '100%'
      }}>
        <input
          type="text"
          value={message}
          onChange={(e) => onMessageChange(e.target.value)}
          placeholder="Type your message here..."
          style={{
            width: '100%',
            height: '36px',
            padding: '0.5rem',
            paddingRight: '88px',
            backgroundColor: 'rgba(55, 65, 81, 0.2)',
            border: '1px solid rgba(75, 85, 99, 0.3)',
            borderRadius: '0.375rem',
            outline: 'none',
            color: 'rgb(255, 255, 255)',
            '::placeholder': { color: '#9ca3af' }
          }}
          maxLength={500}
          disabled={!isConnected}
        />
        <EmojiPicker onEmojiSelect={handleEmojiSelect} />
        <button
          type="submit"
          disabled={!isConnected}
          style={{
            position: 'absolute',
            right: '4px',
            top: '50%',
            transform: 'translateY(-50%)',
            padding: '0.5rem',
            backgroundColor: isConnected ? 'rgba(59, 130, 246, 0.8)' : 'rgba(147, 197, 253, 0.3)',
            color: 'white',
            border: 'none',
            borderRadius: '0.375rem',
            cursor: isConnected ? 'pointer' : 'not-allowed',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '28px',
            width: '36px'
          }}
        >
          <Send size={16} />
        </button>
      </div>
      <div style={{ 
        display: 'flex',
        gap: '0.5rem',
        marginLeft: 'auto'
      }}>
        {canModerate() && (
          <button
            type="button"
            onClick={onModerateClick}
            style={{
              padding: '0.5rem',
              backgroundColor: 'rgba(55, 65, 81, 0.2)',
              color: 'white',
              border: 'none',
              borderRadius: '0.375rem',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '36px',
              height: '28px'
            }}
          >
            <Users size={16} />
          </button>
        )}
        <button
          type="button"
          onClick={onSettingsClick}
          style={{
            padding: '0.5rem',
            backgroundColor: 'rgba(55, 65, 81, 0.2)',
            color: 'white',
            border: 'none',
            borderRadius: '0.375rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '36px',
            height: '28px'
          }}
        >
          <Settings size={16} />
        </button>
      </div>
    </form>
  );
});

ChatInput.displayName = 'ChatInput';

export default ChatInput; 